import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  const phoneNumber = "919896557781"; // Without + or -
  const message = "Hi! I'm interested in Plantora products.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20BA5C] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-6 h-6 fill-white" />
      <span className="font-medium hidden sm:inline">Chat with us</span>
    </a>
  );
};
